import React from "react";
import styled from "styled-components";

const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledButton = styled.button`
  background-color: ${({ backgroundColor }) => backgroundColor || "#000"};
  border: none;
  border-radius: ${({ radius }) => radius || "5px"};
  padding: ${({ padding }) => padding || "10px"};
  width: ${({ width }) => width || "100%"};
  color: ${({ color }) => color || "#fff"};
  font-size: ${({ fontSize }) => fontSize || "1rem"};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

const Button = ({
  border = "1px solid #000",
  radius = "5px",
  onClick = () => {},
  width = "100%",
  padding = "10px",
  backgroundColor = "#000",
  color = "#fff",
  disabled = false,
  fontSize = "1rem",
  style = {},
  className = "",
  children,
}) => {
  const handleClick = (e) => {
    if (!disabled) onClick(e);
  };

  return (
    <Container>
      <StyledButton
        onClick={handleClick}
        disabled={disabled}
        radius={radius}
        width={width}
        padding={padding}
        backgroundColor={backgroundColor}
        color={color}
        fontSize={fontSize}
        className={className}
        style={style}
      >
        {children}
      </StyledButton>
    </Container>
  );
};

export default Button;
